import { FileError, fileUtils } from '@sato/components';

import { useTranslate } from '@hooks/useTranslate';

export const FILE_VALIDATION_OPTIONS = {
  maxFileSizeInMb: 10,
  maxTotalFileSizeInMb: 10,
  maxFileNameLength: 100,
  allowedExtensions:
    fileUtils.DEFAULT_FILE_VALIDATION_OPTIONS.allowedExtensions,
} satisfies typeof fileUtils.DEFAULT_FILE_VALIDATION_OPTIONS;

export const MAX_FILE_COUNT = 10;

export const getFileErrorTranslation = ({
  error,
  translationGetter,
}: {
  error?: FileError;
  translationGetter: ReturnType<typeof useTranslate>['t'];
}) => {
  switch (error) {
    case FileError.ERROR_FILE_NAME:
      return translationGetter('error.ERROR_FILE_NAME', {
        maxLength: FILE_VALIDATION_OPTIONS.maxFileNameLength,
        allowedExtensions: FILE_VALIDATION_OPTIONS.allowedExtensions.join(', '),
      });
    case FileError.ERROR_FILE_SIZE:
      return translationGetter('error.ERROR_FILE_SIZE', {
        maxSize: fileUtils.formatFileSize(
          fileUtils.megabytesToBytes(FILE_VALIDATION_OPTIONS.maxFileSizeInMb)
        ),
      });
    default:
      return undefined;
  }
};

/** Gets a file url from a blob */
export const getFileUrlFromBlobPart = (
  blobPart: BlobPart,
  { fileName, type }: { fileName: string; type: string }
) => {
  const file = new File([blobPart], fileName, { type });

  return URL.createObjectURL(file);
};

export const base64ToBlob = async (base64Url: string) => {
  const res = await fetch(base64Url);
  return res.blob();
};
